var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4397 11.7148H24.5V11.6663H14V16.333H20.5934C19.6315 19.0496 17.0467 20.9997 14 20.9997C10.1342 20.9997 6.99998 17.8654 6.99998 13.9997C6.99998 10.1339 10.1342 6.99967 14 6.99967C15.7844 6.99967 17.4078 7.67284 18.6439 8.77242L21.9438 5.47251C19.8601 3.53059 17.073 2.33301 14 2.33301C7.55706 2.33301 2.33331 7.55676 2.33331 13.9997C2.33331 20.4426 7.55706 25.6663 14 25.6663C20.4429 25.6663 25.6666 20.4426 25.6666 13.9997C25.6666 13.2174 25.5861 12.4538 25.4397 11.7148Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67853 8.56943L7.51161 11.3805C8.54878 8.81267 11.0606 6.99967 14 6.99967C15.7844 6.99967 17.4079 7.67284 18.6439 8.77242L21.9439 5.47251C19.8602 3.53059 17.073 2.33301 14 2.33301C9.51886 2.33301 5.63269 4.86292 3.67853 8.56943Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6671C17.0135 25.6671 19.7517 24.5138 21.8219 22.6384L18.2111 19.5829C17.0004 20.5036 15.521 21.0016 14 21.0004C10.9655 21.0004 8.38894 19.0655 7.41827 16.3652L3.61377 19.2965C5.5446 23.0747 9.46577 25.6671 14 25.6671Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4398 11.7154H24.5V11.667H14V16.3337H20.5934C20.1333 17.6266 19.3045 18.7563 18.2093 19.5834L18.2111 19.5822L21.8219 22.6377C21.5664 22.8699 25.6667 19.8337 25.6667 14.0003C25.6667 13.2181 25.5862 12.4545 25.4398 11.7154Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.2a641257c5a20429c5f53488ac6c7295.svg";
export { ForwardRef as ReactComponent };